import { render, staticRenderFns } from "./nopermission.vue?vue&type=template&id=4e41f5b2&scoped=true&"
import script from "./nopermission.vue?vue&type=script&lang=js&"
export * from "./nopermission.vue?vue&type=script&lang=js&"
import style0 from "./nopermission.vue?vue&type=style&index=0&id=4e41f5b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e41f5b2",
  null
  
)

export default component.exports